import Swal from 'sweetalert2';
import { Color } from '../../assets/color';
import * as actionTypes from "../action-types";
import { deleteAPI, getAPI, patchAPI, postAPI } from '../../utils/api-function';
import { put, call, takeLeading } from 'redux-saga/effects';
import {
    //* customer
    get_customers, get_customer_by_id,

    //* Customer Report Wallet
    get_customer_report_wallets, create_customer_report_wallet, update_customer_report_wallet, delete_customer_report_wallet

} from '../../utils/api-routes';

//! Customer
function* getCustomers() {
    try {
        const { data } = yield getAPI(get_customers);
        console.log("Get customers Saga Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMERS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_CUSTOMERS, payload: [] });
        }

    } catch (error) {
        console.log("Get customers Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_CUSTOMERS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* getCustomerById(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield getAPI(get_customer_by_id(payload));
        console.log("Get customer By ID Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMER_BY_ID, payload: data.result });
        }

    } catch (error) {
        console.log("Get customer By ID Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_CUSTOMER_BY_ID, payload: {} });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

//! Customer Report Wallet
function* getCustomerReportWallets() {
    try {
        const { data } = yield getAPI(get_customer_report_wallets);
        console.log("Customer Report Wallets Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMER_REPORT_WALLETS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_CUSTOMER_REPORT_WALLETS, payload: [] });
        }
    } catch (error) {
        console.log("Customer Report Wallets Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
        yield put({ type: actionTypes.SET_CUSTOMER_REPORT_WALLETS, payload: [] });
    }
};

function* createCustomerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to add token in customer wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_customer_report_wallet, payload?.data);
            console.log("Create Customer Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_CUSTOMER_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Create Customer Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updateCustomerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this entry and token in customer wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_customer_report_wallet(payload?.id), payload?.data);
            console.log("Update Customer Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_CUSTOMER_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Update Customer Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deleteCustomerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this entry and token in customer wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_customer_report_wallet(payload?.id));
            console.log("Delete Customer Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_CUSTOMER_REPORT_WALLETS });
            }
        }
    } catch (error) {
        console.log("Delete Customer Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

export default function* partnerSaga() {
    //! Customer
    yield takeLeading(actionTypes.GET_CUSTOMERS, getCustomers);
    yield takeLeading(actionTypes.GET_CUSTOMER_BY_ID, getCustomerById);

    //! Customer Report Wallet
    yield takeLeading(actionTypes.GET_CUSTOMER_REPORT_WALLETS, getCustomerReportWallets);
    yield takeLeading(actionTypes.CREATE_CUSTOMER_REPORT_WALLET, createCustomerReportWallet);
    yield takeLeading(actionTypes.UPDATE_CUSTOMER_REPORT_WALLET, updateCustomerReportWallet);
    yield takeLeading(actionTypes.DELETE_CUSTOMER_REPORT_WALLET, deleteCustomerReportWallet);
};